module.exports = __webpack_public_path__ + "img/mini-program-icon.b54381be.svg";